import { Check } from "@phosphor-icons/react";

export default function Stepper({ steps, current, onJump }) {
  return (
    <div className="border border-[#E5E7EB] bg-white rounded-md p-4 md:p-6 mb-6">
      <div className="grid grid-cols-2 md:grid-cols-7 gap-3 md:gap-2">
        {steps.map((s, i) => {
          const isDone = i < current;
          const isActive = i === current;
          return (
            <button
              key={s.key}
              onClick={() => onJump?.(i)}
              data-testid={`stepper-step-${i}`}
              className="text-left group"
            >
              <div className="flex items-start gap-2">
                <div
                  className={`shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold border-2 transition-colors ${
                    isActive
                      ? "bg-[#1E3A5F] text-white border-[#1E3A5F]"
                      : isDone
                      ? "bg-[#10B981] text-white border-[#10B981]"
                      : "bg-white text-[#6B7280] border-[#E5E7EB]"
                  }`}
                >
                  {isDone ? <Check size={14} weight="bold" /> : i + 1}
                </div>
                <div className="leading-tight">
                  <div
                    className={`text-[10px] uppercase tracking-[0.15em] font-bold ${
                      isActive ? "text-[#1E3A5F]" : "text-[#6B7280]"
                    }`}
                  >
                    Step {i + 1}
                  </div>
                  <div
                    className={`text-xs md:text-sm font-semibold ${
                      isActive ? "text-[#1E3A5F]" : "text-[#111827]"
                    }`}
                  >
                    {s.label}
                  </div>
                </div>
              </div>
              <div
                className={`mt-2 h-0.5 w-full ${
                  isActive ? "bg-[#16A34A]" : isDone ? "bg-[#10B981]" : "bg-[#E5E7EB]"
                }`}
              />
            </button>
          );
        })}
      </div>
    </div>
  );
}
